import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import FctvaPanel from '../panel/FctvaPanel';
import InventairePanel from '../panel/InventairePanel';
import ProjetPanel from '../panel/ProjetPanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';

class ProfilEcritureOrdreBudgetaireSectionASectionInvestissementAvecInfoInventaire extends BaseProfilEcritureDepense {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_SECT_A_SECT_INVES_AVEC_INFO_INV;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.INVENTAIRE;
    this.typePiece = TYPE_PIECE.DEPENSE.ORDRE_BUDGET;
    this.imputation.nature = Nature.ORDRE;
    this.imputation.chapitre = '040';
    this.modeDeReglement = [
      MODE_REGLEMENT.DEPENSE.OPERATION_ORDRE,
      MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE,
    ];
    this.panels = [
      new FctvaPanel(),
      new SaisieLibrePanel(),
      new InventairePanel(true),
      new ProjetPanel(),
    // TODO : add "Marche public" optional panel
    ];
  }
}

export default ProfilEcritureOrdreBudgetaireSectionASectionInvestissementAvecInfoInventaire;
